/**
 * Athos v1 configuration utilities.
 * Site IDs come from the athos_* theme settings via ATHOS_STATE.
 */

export function getAthosSiteID(category = 'products') {
  return window.ATHOS_STATE?.siteIds?.[category]
}

export function getApiOrigin(siteID) {
  return `https://${siteID}.a.athoscommerce.net/v1`
}

export function getPersonalizationOrigin(siteID) {
  return `https://${siteID}.a.p13n.athoscommerce.net/v1`
}

export function getBeaconOrigin() {
  return 'https://analytics.athoscommerce.net/beacon/v2'
}

export function getAthosDomain() {
  return window.location.href
}

export function isAthosInstockOnly() {
  return window.ATHOS_STATE?.instockOnly === true
}
